export default __webpack_public_path__ + "static/media/deezer-bw.bafdd4e1.svg";